import styles from '../storeLocator/mapStyles';
const renderInfoWindow = (item, resources) => {
    var storeHours = $('.store-hours-' + item.ID).length > 0 ? '<br>' + $('.store-hours-' + item.ID)[0].outerHTML : '';
    item.storeOpenUntilLabel = item.storeOpenUntilLabel ? item.storeOpenUntilLabel.split('"').join("'") : '';
    let untilOpenLabelValue = $('.store-hours[data-store-id="' + item.ID + '"] .js-store-next-phase').length > 0 ?
        $('.store-hours[data-store-id="' + item.ID + '"] .js-store-next-phase').eq(0).html() :
        '';
    if (untilOpenLabelValue !== '') {
        item.storeOpenUntilLabel = item.storeOpenUntilLabel.replace('&nbsp;', untilOpenLabelValue);
    }
    let built = `
        <div class="primary-info">
            <div><svg class="pin-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="20" rx="10" fill="#1C1C1C"></rect>
            <path d="M15 5.5H5V7.42003H8.70944V15.5H11.2901V7.42003H15V5.5Z" fill="white"></path>
            </svg>
            <h6>${item.name}</h6>
            </div>
            <span>${item.distance}</span>
        </div>
        <p>${item.address1}, <br>${item.city} ${item.postalCode}</p>`;
    // Checkout page (GetStoresForRRPV)
    if (resources.chooseStore) {
        built += `<div><div class="spacer small"></div><button type="button" class="button no-margin js-choose-store-infowindow font-size-12" data-store-id="${item.ID}">${resources.chooseStore}</button></div>`;
    } else { // PDP page (GetStoresWithProductAvailability)
        built += `
            <p class="strong">${item.sizeLabel} ${item.sizeCode} <span class="${item.availability === 'high' ? 'text-brand-green' : 'text-medium-gray'}">${item.availabilityLabel}</span>
            ${storeHours} ${item.storeOpenUntilLabel}</p>
            <button class="show-details js-findinstorepdp" data-store-name="${item.name}" data-name="click_result_of_the_shops_listing">${resources.showOnMap}</button>
            <div class="item-info hide">${JSON.stringify(item)}</div>
            <a target="_blank" class="force-hover hidden" data-href="//www.google.com/maps/place/${item.latitude},${item.longitude}">${resources.getDirections}</a>`;
    }
    return built;
};

/* eslint-disable no-undef */
export default class Map {
    constructor ($target, initialCoordinates = [42, 12]) {
        this.$target = $target;
        this.previousQuery = '';
        this.markers = [];
        this.initialCoordinates = initialCoordinates;
        if ($('meta[http-equiv=content-language]').attr('content') === 'ja-JP') {
            this.minCharSearch = 2;
        } else {
            this.minCharSearch = 3;
        }
    }

    init () {
        const self = this;
        const latlng = new google.maps.LatLng(this.initialCoordinates[0], this.initialCoordinates[1]);
        const mapOptions = {
            scrollwheel: false,
            zoom: 8,
            center: latlng,
            styles
        };

        this.map = new google.maps.Map(this.$target[0], mapOptions);
        this.bounds = new google.maps.LatLngBounds();
        this.infowindow = new google.maps.InfoWindow();

        // Reset zoom after fit bounds
        google.maps.event.addListener(self.map, 'zoom_changed', function () {
            var zoomChangeBoundsListener = google.maps.event.addListener(self.map, 'bounds_changed', function (event) {
                if (this.getZoom() > 12 && this.initialZoom === true) {
                    // Change max/min zoom here
                    this.setZoom(12);
                    this.initialZoom = false;
                }
                google.maps.event.removeListener(zoomChangeBoundsListener);
            });
        });

        this.map.initialZoom = true;
    }

    centerMapOnCoordinates (coordinates = {lat: 0, lng: 0}, zoom = 12) {
        this.map.setCenter({ lat: coordinates.lat, lng: coordinates.lng });
        this.map.setZoom(zoom);
    }

    fitBounds (stores) {
        // Fit the all the store marks in the center of a minimum bounds when any store has been found.
        if (stores && stores.length) {
            this.map.fitBounds(this.bounds);

            // If only one store is found, center and zoom on it
            if (stores.length === 1) {
                this.centerMapOnCoordinates({ lat: stores[0].store.latitude, lng: stores[0].store.longitude }, 12);
            }
        }
    }

    updateMarkers (stores, resources) {
        // Delete markers
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
        const labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let labelsIndex = 0;
        // Reset markers and bounds
        this.markers = [];
        this.bounds = new google.maps.LatLngBounds();

        const icon = {
            url: this.$target.data('marker-url'),
            labelOrigin: new google.maps.Point(8, 9)
        };

        stores.forEach((store) => {
            const item = store.store;
            store.store.distance = store.distance;
            store.store.sizeLabel = store.sizeLabel;
            store.store.sizeCode = store.sizeCode;
            store.store.availabilityLabel = store.availabilityLabel;
            store.store.storeOpenUntilLabel = store.storeOpenUntilLabel;
            store.store.availability = store.availability;
            store.store.storeUrl = store.storeUrl;
            const storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
            const marker = new google.maps.Marker({
                position: storeLocation,
                map: this.map,
                title: item.name,
                icon: icon,
                label: {
                    text: labels[labelsIndex++ % labels.length],
                    color: 'white',
                    fontSize: '10px',
                    lineHeight: '14px',
                    fontWeight: '600',
                    fontFamily: "'Spezia',Helvetica,Arial,sans-serif"
                }
            });

            this.markers.push(marker);

            marker.addListener('click', () => {
                this.infowindow.setOptions({
                    content: renderInfoWindow(item, resources)
                });
                this.infowindow.open(this.map, marker);
                $('body').trigger('analytics:clickonStoreMarker', item);

                $('body').on('click', '.js-findinstorepdp', function (e) {
                    let itemJSON = $(e.currentTarget).parent().find('.item-info').html().replace('"js-store-next-phase"', "'js-store-next-phase'");
                    let itemStore = JSON.parse(itemJSON);
                    $('body').trigger('clickonStoreMarkerInfo', itemStore);
                });
            });

            // Create a minimum bound based on a set of storeLocations
            this.bounds.extend(marker.position);
        });

        this.fitBounds(stores);
    }

    updateCoordinates (coordinates) {
        // If there are no markers yet, center zoom to current position
        if (!this.markers.length) {
            this.centerMapOnCoordinates({ lat: coordinates.lat, lng: coordinates.long }, 10);
        }
    }

    geocode (query = '', countryCode = 'US', $target) {
        // eslint-disable-next-line no-undef
        if (query.length < this.minCharSearch || query === this.previousQuery) {
            return null;
        }

        // Save previous query to avoid Geocoding the same location multiple times
        this.previousQuery = query;

        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({'address': query, 'componentRestrictions': {'country': countryCode}}, (res, status) => {
            if (res.length && status === 'OK') {
                const coords = {
                    lat: res[0].geometry.location.lat(),
                    long: res[0].geometry.location.lng()
                };

                $target.trigger('geocode:update', {
                    success: status === 'OK',
                    data: coords
                });
            } else {
                $target.trigger('geocode:update', {
                    success: status === 'OK',
                    status: status
                });
            }
        });
    }
}
